import { Container, Sprite } from 'pixi.js';
import { createBitmapText } from '../../../Utils/Utils';

export abstract class CircularBar extends Container {
    protected depleteTime: number = 0;
    protected startTime: number;
    protected label: PIXI.extras.BitmapText;
    protected barMask: PIXI.Graphics;
    protected pausedTime: number = 0;
    protected pauseTime: number = 0;
    protected paused: boolean = false;
    protected remainingTime: number;

    protected constructor(labelText: string) {
        super();

        const fill = new Sprite(PIXI.utils.TextureCache['gameui/top-hud-combo-fill']);
        fill.anchor.set(0.5);
        const barMask = new PIXI.Graphics();
        barMask.beginFill(0x000000);
        fill.mask = barMask;
        const numBg = new Sprite(PIXI.utils.TextureCache['gameui/top-hud-combo-number-bg']);
        numBg.anchor.set(0.5);
        const label = createBitmapText(
            labelText,
            new PIXI.Rectangle(0, 0, numBg.width * 0.5, numBg.height * 0.5),
            'riffic',
            26,
            0xfffa11
        );
        label.anchor = 0.5;
        label.y = label.height / 4;
        //@ts-ignore
        this.addChild(fill, numBg, label, barMask);
        this.label = label;
        this.barMask = barMask;
        this.barMask.alpha = 0.5;
        this.startTime = Date.now();
    }

    public tick(force?: boolean) {
        if (this.paused && !force) {
            return false;
        }
        const timePassed = Date.now() - this.startTime;

        this.remainingTime = this.depleteTime - (timePassed - this.pausedTime);

        const percentLeft = this.remainingTime / this.depleteTime;
        this.drawMask(percentLeft);
        return true;
    }

    public drawMask(percent: number) {
        percent = Math.min(1, Math.max(0, percent));
        this.barMask.clear();
        this.barMask.beginFill(0x000000);
        const degs: number = 360 * percent;
        const rads = degs * (Math.PI / 180);
        const start = -90 * (Math.PI / 180);
        const fillWidth = (this.getChildAt(0) as Sprite).width / 2;
        this.barMask.moveTo(0, 0);
        this.barMask.arc(0, 0, fillWidth, start, rads + start);
        this.barMask.currentPath.shape.closed = false;
    }

    public setPaused(paused: boolean) {
        if (paused === this.paused) {
            return;
        }
        this.paused = paused;
        if (paused) {
            this.pauseTime = Date.now();
        } else {
            this.pausedTime += Date.now() - this.pauseTime;
        }
    }

    public cleanUp() {
        this.barMask.destroy();
        this.label.destroy();
        this.destroy();
    }
}
